import { CheckoutProfileService } from '@commerce-checkout-webcomponents/sdk';
import { ShippingTypeEnums, checkoutShippingOptions } from '@commerce-checkout-webcomponents/ui';
import { MasterDataService } from '@nextgen-web-framework/core';
import { Config } from '@com.amway.commerce/webshop-configs-v1-prod/Schema';

const getAddressToDisplay = (isContentNicknameEnabled: boolean, nickname?: string, deliveryAddress = ''): string =>
  isContentNicknameEnabled && nickname?.trim() ? nickname : deliveryAddress;

const getCurrentAddress = () => {
  const address = CheckoutProfileService.getCheckoutProfile();
  let currentAddress = '';
  let shippingType = ShippingTypeEnums.DELIVERY;
  let addressToDisplay = '';
  let postalCodeToDisplay = '';
  const webShopConfigs = MasterDataService.getMasterData<Config>('WebshopConfigs') as Config;
  const isContentNicknameEnabled = webShopConfigs?.contactNickName;

  if (address) {
    if (
      address.fulfillmentType.id === checkoutShippingOptions.HOMEDELIVERY &&
      address.fulfillmentType.serviceLevel?.deliveryAddress
    ) {
      const nickname = address.fulfillmentType.serviceLevel?.deliveryAddress?.contactNickname;
      const deliveryAddress = address.fulfillmentType.serviceLevel?.deliveryAddress?.addrLineOne ?? '';
      addressToDisplay = getAddressToDisplay(!!isContentNicknameEnabled, nickname, deliveryAddress);
      postalCodeToDisplay = `${address.fulfillmentType.serviceLevel?.deliveryAddress?.postalCode}`;
      currentAddress = `${textEllipsis(deliveryAddress, 14)} , ${postalCodeToDisplay}`;
    } else if (
      address.fulfillmentType.serviceLocation?.address &&
      address.fulfillmentType.id !== checkoutShippingOptions.HOMEDELIVERY
    ) {
      let showPickUpAddress = '';
      const pickupAddress = address.fulfillmentType.serviceLocation?.name ?? '';
      addressToDisplay = pickupAddress;
      if (address.fulfillmentType.id == checkoutShippingOptions.BOPIS) {
        const pickupId = address.fulfillmentType.serviceLocation?.id;
        currentAddress = `${textEllipsis(pickupAddress, 15)} : ${pickupId}`;
      } else {
        showPickUpAddress = `${pickupAddress}`;
        currentAddress = `${textEllipsis(showPickUpAddress, 25)}`;
      }
      shippingType = ShippingTypeEnums.PICKUP;
    }
  }
  return {
    currentAddress,
    shippingType,
    addressToDisplay,
    postalCodeToDisplay,
  };
};

const textEllipsis = (str: string, maxLength: number, { ellipsis = '...' } = {}) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength - ellipsis.length) + ellipsis;
  }
  return str;
};
export { getCurrentAddress, textEllipsis };
